"use client";

import Link from "next/link";
import { useLanguage } from "@/lib/i18n/context";
import { usePathname } from "next/navigation";

export function Footer() {
  const { t } = useLanguage();
  const pathname = usePathname();
  const isServicesOrHome = pathname === "/" || pathname?.includes("/uslugi");

  return (
    <footer className="relative w-full overflow-hidden bg-stone-100 dark:bg-zinc-900">
      <div
        aria-hidden="true"
        className="absolute inset-0 opacity-[0.025] dark:opacity-[0.04] pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(rgba(0,0,0,.15) 1px, transparent 1px), linear-gradient(90deg, rgba(0,0,0,.15) 1px, transparent 1px)",
          backgroundSize: "32px 32px",
        }}
      />

      <div className="relative z-10 mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 flex flex-col items-center justify-center space-y-8">
        {/* Navigation Links */}
        <nav className="flex flex-wrap justify-center gap-x-8 gap-y-4 text-sm font-medium text-zinc-600 dark:text-zinc-400">
          <Link href="/" className="transition-colors hover:text-orange-600 dark:hover:text-orange-400">
            {t.nav.home}
          </Link>
          <Link href="/o-nas" className="transition-colors hover:text-orange-600 dark:hover:text-orange-400">
            {t.nav.about}
          </Link>
          <Link href="/uslugi" className="transition-colors hover:text-orange-600 dark:hover:text-orange-400">
            {t.nav.services}
          </Link>
          <Link href="/kontakt" className="transition-colors hover:text-orange-600 dark:hover:text-orange-400">
            {t.nav.contact}
          </Link>
        </nav>

        {/* Copyright */}
        <div className="flex flex-col items-center space-y-2">
          <p className="text-center text-sm text-zinc-500 dark:text-zinc-500">
            &copy; {new Date().getFullYear()} Automatyka CNC Dariusz Król. {t.footer.allRightsReserved}
          </p>
        </div>
      </div>
    </footer>
  );
}
